import { Typography } from "antd"
import React from "react"

export function DividerBlock() {
  return (
    <Typography.Text type="secondary" italic className="block text-center py-2">
      Horizontal divider — no configuration needed
    </Typography.Text>
  )
}
